import axios from 'axios';
import { mapSchedule, mapVods } from '../services/mapResponse';
import postProcessSchedule from '../services/postProcessSchedule';

export const getSchedule = async (citySlug, scope = 'imkino') => {
  const { data } = await axios.get(`/schedule/${citySlug}/?isExternal=0`);
  const mappedSchedule = mapSchedule(data);
  const processedSchedule = await postProcessSchedule(mappedSchedule, scope);

  return processedSchedule;
};

export const getScheduleAndVods = async (citySlug, scope = 'imkino') => {
  const [{ data: schedule }, { data: vods }] = await axios.all([
    axios.get(`/schedule/${citySlug}/?isExternal=0`),
    axios.get('/schedule/vods/')
  ]);

  const mappedVods = mapVods(vods);
  const mappedSchedule = mapSchedule(schedule);
  const processedSchedule = await postProcessSchedule(mappedSchedule, scope);

  return [processedSchedule, mappedVods];
};
